import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Add Training Institute Detail")
], -1)
const _hoisted_2 = { class: "card mb-5 mb-xl-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-primary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Room Detail")
  ])
], -1)
const _hoisted_4 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mt-3" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Training Institute")
], -1)
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Room No", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Room Location", -1)
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Room Capacity", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Room Equipment")
    ]),
    /*#__PURE__*/_createElementVNode("textarea", {
      name: "room_equipment",
      id: "room_equipment",
      rows: "10",
      class: "form-control"
    })
  ])
], -1)
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "d-flex" }
const _hoisted_20 = ["data-kt-indicator"]
const _hoisted_21 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_22 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_23 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Traininig Institute",
                    modelValue: _ctx.entity.entity_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.entity.entity_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString("[" + info.entity_short_name + "] - " + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "room_no",
                    class: "form-control form-control-sm",
                    rows: "3"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "room_no",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_Field, {
                    name: "room_location",
                    class: "form-control form-control-sm"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "room_location",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_Field, {
                    name: "room_capacity",
                    class: "form-control form-control-sm"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "room_capacity",
                    class: "fv-plugins-message-container invalid-feedback"
                  })
                ])
              ]),
              _hoisted_17
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary",
              type: "submit",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.formSubmit()))
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                    _createTextVNode(" Submit "),
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                    _createTextVNode(" Please wait... "),
                    _hoisted_24
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_20)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}